import { FormProvider, useForm } from "react-hook-form";
import {
  LetterBatchesFilterFormData,
  LetterBatchesFilterSchema,
  defaultDateRange,
} from "./LetterBatchesFilterSchema";
import { zodResolver } from "@hookform/resolvers/zod";

export const LetterBatchesFilterFormProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const methods = useForm<LetterBatchesFilterFormData>({
    mode: "onChange",
    resolver: zodResolver(LetterBatchesFilterSchema),
    defaultValues: {
      search: "",
      startDate: defaultDateRange.startDate,
      endDate: defaultDateRange.endDate,
    },
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
